import { createContext } from "react";

export const RegisterFriendContext = createContext<number | null>(null);
